import type { Href } from "expo-router";
import { useRouter } from "expo-router";
import { useEffect } from "react";
import { ActivityIndicator, View } from "react-native";

import { CoravuMarketingLanding } from "../components/marketing/CoravuMarketingLanding";
import { MarketingHead } from "../components/MarketingHead";
import { PANE_THEMES } from "../components/brand/paneThemes";
import { getMyJudgeAssignments } from "../lib/judges";
import { roleToRoute } from "../lib/auth";
import { useAuth } from "../lib/authContext";
import { META_LANDING } from "../lib/marketingMeta";

const THEME = PANE_THEMES.General;

export default function Index() {
  // Clear the signing-out flag once we land on the marketing landing.
  // PortalGate suppresses /login redirects while this is set; once we
  // are here the brief sign-out race is over.
  if (typeof window !== "undefined") {
    try {
      window.sessionStorage?.removeItem("coravu_signing_out");
    } catch {
      // ignore
    }
  }

  const { user, role, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (loading) return;
    void (async () => {
      if (!user) {
        return;
      }
      if (!role) {
        const judgeAssignments = await getMyJudgeAssignments();
        if (judgeAssignments.length > 0) {
          router.replace("/judge" as Href);
          return;
        }
        router.replace("/login");
        return;
      }
      router.replace(roleToRoute(role) as Href);
    })();
  }, [loading, user, role, router]);

  if (loading) {
    return (
      <View className="flex-1 items-center justify-center bg-bg">
        <ActivityIndicator size="large" color={THEME.accent} />
      </View>
    );
  }

  if (user) {
    return (
      <View className="flex-1 items-center justify-center bg-bg">
        <ActivityIndicator size="large" color={THEME.accent} />
      </View>
    );
  }

  return (
    <>
      <MarketingHead meta={META_LANDING} />
      <CoravuMarketingLanding />
    </>
  );
}
